import { ChangeEvent, useContext, useState } from 'react';
import InputMask from 'react-input-mask-next'
import { format, isAfter, parse } from 'date-fns';
import { useQueryClient } from '@tanstack/react-query';
import { useModal } from '../../../../hooks/ModalContext';
import { Button } from '../../../generics/button';
import { QueueProps, useFila } from '../../../../context/FilaContext';
import { useClear } from '../../../../hooks/useClear';
import { useDividas } from '../../../../context/DividasContext';
import { usePropostas } from '../../../../context/PropostasContext';
import { RequestAcionamento } from '../../../../types/resgitro-acionamento-interface';
import { Telefones } from '../../../../types/devedor-interface';
import { useHistorico } from '../../../../context/HistoricoContext';
import { useChatWhatsApp } from '../../../../context/ChatWhatsAppContext';
import { useAuth } from '../../../../context/AuthContext';
import { SelectTabulacao } from './select-tabualcao';
import { DiscadorContext } from '../../../Discador';


interface Item {
  id: string;
  descricao: string;
  permiteagendamento: string;
  finalizador: string;
  telefoneobrigatorio: string;
  tipoacionamento?: string;
}

interface TabulacaoProps {
  isHibrido?: boolean;
  isOperador?: boolean
  app?: string
}

export const Tabulacao = ({ isHibrido, isOperador, app }: TabulacaoProps) => {
  const queryClient = useQueryClient();
  const { setModal, onClose } = useModal();
  const { endQueue, devedorFilaSelected, clearSelectedFila, getChatId, getDevedorFilaSelected, fila } = useFila();
  const { selectedCredor, devedorCadastro } = useDividas();
  const { clearData } = useClear();
  const { sendAcionamento } = usePropostas();
  const { getHistorico } = useHistorico();
  const { endChat } = useChatWhatsApp();
  const { cookies } = useAuth();
  const { dadosChamada } = useContext(DiscadorContext)

  const [tabualacao, setTabulacao] = useState<Item>({} as Item);
  const [observacao, setObservacao] = useState('');
  const [telefoneAgendamento, setTelefoneAgendamento] = useState('');
  const [telefoneAgendamentoDigitado, setTelefoneAgendamentoDigitado] = useState('')
  const [dataAgendamento, setDataAgendamento] = useState('');
  const [horaAgendamento, setHoraAgendamento] = useState('');
  const [isAgendamento, setIsAgendamento] = useState(false);

  const appWS = app ? app : isOperador ? 'ACIONA_OPE' : 'ACIONA_WEB'

  const listaSMS =
    devedorCadastro?.telefones?.telefonecliente && devedorCadastro?.telefones?.telefonecliente.length > 0
      ? devedorCadastro?.telefones.telefonecliente.filter(
        (item) => item.situacaotelefone === 'Valido' || item.situacaotelefone === 'Contactado'
      )
      : ([] as Telefones[]);

  function removerDuplicadosPorPropriedade(array: Telefones[]) {
    return array.filter((obj, index, self) => index === self.findIndex((el) => el['telefone'] === obj['telefone']));
  }

  const listaTelefone =
    listaSMS && listaSMS?.length > 0 ? removerDuplicadosPorPropriedade(listaSMS) : ([] as Telefones[]);

  // const sitcob = useMutation({
  //   mutationFn: () =>
  //     apiModulo.post('/options', {
  //       codcredor: selectedCredor.credor_crm,
  //       url: selectedCredor.url_ws,
  //       legenda: 'SITCOB',
  //       app: isOperador ? 'ACIONA_OPE' : 'ACIONA_WEB',
  //     }),
  // });

  function formatDate(date: string) {
    if (date) {
      const [ano, mes, dia] = date?.split('-');
      return `${dia}/${mes}/${ano}`;
    }
    return '';
  }

  function verificaDataAgendamento() {
    const dataHoraSelecionada = parse(`${dataAgendamento} ${horaAgendamento}`, 'yyyy-MM-dd HH:mm', new Date());
    if (!isAfter(dataHoraSelecionada, new Date())) {
      return false;
    }
    return true;
  }

  async function handleEndChat() {
    const id_chat = devedorFilaSelected.id_chat || '';
    const token = cookies?.whatsapp?.token || '';
    await endChat(id_chat, token);
    await getChatId(Number(devedorFilaSelected.id_queue), '');
    await queryClient.refetchQueries({ queryKey: ['atendimento'] });
    if (fila && devedorFilaSelected?.cpf_cnpj) {
      getDevedorFilaSelected(
        fila.find((item) => item.cpf_cnpj === devedorFilaSelected?.cpf_cnpj) || ({} as QueueProps)
      );
    }
  }

  async function handleTabular() {
    if (tabualacao.telefoneobrigatorio === 'true' && telefoneAgendamento === '' && !isHibrido) {
      setModal('Escolha um telefone para tabulação', 'Erro', false, true);
      return;
    }

    if (isHibrido && !dadosChamada?.call?.phone && telefoneAgendamentoDigitado === '' && telefoneAgendamento === '') {
      setModal('Escolha um telefone para tabulação', 'Erro', false, true);
      return;
    }

    const isHoraDepois = isAgendamento && verificaDataAgendamento();

    if (!isHoraDepois && isAgendamento) {
      setModal('A data e hora devem ser posteriores à atual.', 'Erro', false, true);
      return;
    }

    // if (isHibrido) {
    //   contrato = returnP4(dadosChamada.contrato);
    // } else {
    //   contrato = devedorFilaSelected.cpf_cnpj ? devedorFilaSelected.cpf_cnpj : devedorCadastro.cpfcnpj;
    // }

    let acionamento: RequestAcionamento = {
      app: appWS,
      cpfCnpj: devedorFilaSelected.cpf_cnpj ? devedorFilaSelected.cpf_cnpj : devedorCadastro.cpfcnpj,
      credor: selectedCredor.credor_crm ? String(selectedCredor.credor_crm) : '434',
      empresa: 'GAZIN',
      idacionamento: tabualacao.id,
      observacao,
      stage: '0',
      telefone: telefoneAgendamento, // adicionar dps o telefone do discador
      tipo: tabualacao.tipoacionamento || 'POSICAO',
      usuario: String(cookies?.user?.id_operador),
      agendamento: dataAgendamento !== '' ? `${formatDate(dataAgendamento)} ${horaAgendamento}:00` : '',
      telefoneagendamento: telefoneAgendamento,
      url: selectedCredor.url_ws,
      contrato: '',
    };

    if (isHibrido && !dadosChamada?.call?.phone) {
      acionamento.telefone = telefoneAgendamentoDigitado !== '' ? telefoneAgendamentoDigitado : telefoneAgendamento
      if (dataAgendamento) acionamento.telefoneagendamento = acionamento.telefone
    }

    if (isHibrido && dadosChamada?.call?.phone) {
      acionamento.telefone = dadosChamada?.call?.phone
      if (dataAgendamento) acionamento.telefoneagendamento = telefoneAgendamentoDigitado !== '' ? telefoneAgendamentoDigitado.replace(/\D/g, '') : dadosChamada?.call?.phone
    }

    setObservacao('');

    await sendAcionamento(acionamento);
    if (tabualacao.finalizador === 'true') {
      if (devedorFilaSelected?.id_chat) {
        await handleEndChat();
      }
      setModal('Tabulação feita com sucesso!', 'Sucesso', true, false);
      if (!isHibrido && !isOperador) {
        await endQueue(devedorFilaSelected.id_queue);
        clearSelectedFila();
        clearData();
        onClose();
        setModal('Proximo Atendimento', 'Atendimento');
      }
    }

    await getHistorico({
      url: selectedCredor?.url_ws,
      cpf_cnpj: devedorFilaSelected?.cpf_cnpj ? devedorFilaSelected.cpf_cnpj : devedorCadastro.cpfcnpj,
      codcredor: String(selectedCredor?.credor_crm),
      app: appWS,
      usuario: String(cookies?.user?.id_operador),
    });
    onClose();
    // setModal('Tabulação feita com sucesso!', 'Finalizar Tabulação', false, false)
    setModal('Tabulação feita com sucesso!', 'Sucesso', true, false);
  }

  function formatarTelefone(telefone: string) {
    telefone = telefone?.replace(/\D/g, '');
    telefone = telefone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  return (
    <div className="flex flex-col items-center">
      <div className="w-full">
        <div className="flex w-full flex-col ">
          <div className="m-2 mx-0 flex w-full items-center gap-4 ">
            <div className=" my-2 flex w-[65%] flex-col gap-2">
              <p className="text-sm font-medium text-gray-500">Tabulação</p>
              <SelectTabulacao
                onSelectChange={(value) => {
                  setTabulacao(value);
                  // console.log(value);
                }}
                value={tabualacao.id}
                // onChange={(e) => {
                // console.log(e.target.value);
                // console.log(e.target.labels);
                // setTabulacao(
                //   (sitcob.data?.data &&
                //     sitcob.data.data?.message?.lista?.item?.find((item: Item) => item.id === e.target.value)) ||
                //     ({} as Item)
                // );
                // }}
                isAgendamento={isAgendamento}
                isOperador={isOperador}
                app={appWS}
              />
            </div>

            {
              app === 'ACIONA_CXA' ? (<></>) : (<div className="mt-6 flex items-center gap-2">

                <input
                  type="checkbox"
                  name="agendamento"
                  id="agendamento"
                  onChange={() => setIsAgendamento(!isAgendamento)}
                />
                <label htmlFor="agendamento" className="text-sm">
                  Agendamento
                </label>
              </div>
              )
            }

          </div>
        </div>

        <div className={`flex  ${isHibrido ? 'items-start' : 'items-center'} gap-2`}>
          <div className='w-[65%]'>
            {
              ((isHibrido && !dadosChamada?.call?.phone) || !isHibrido) && (
                <div className=" mb-2 flex  flex-col gap-2">
                  <p className="text-sm font-medium text-gray-500">
                    Telefones cadastrados ({tabualacao.telefoneobrigatorio === 'true' ? 'obrigatório' : 'opcional'})
                  </p>
                  <select
                    className="w-full rounded-sm bg-gray-200 p-2 text-xs text-gray-600 outline-none"
                    name="telefoneAgendamento"
                    value={telefoneAgendamento}
                    onChange={(e) => setTelefoneAgendamento(e.target.value)}
                  >
                    <option value=""></option>
                    {listaTelefone &&
                      listaTelefone.length > 0 &&
                      listaTelefone.map((tel) => (
                        <option key={tel.id_telefone} value={tel.telefone}>
                          {formatarTelefone(tel.telefone)}
                        </option>
                      ))}
                  </select>
                  {/* 
            <input type="text" className=" block rounded-md border border-gray-300 bg-gray-100 px-2.5 py-1.5 text-sm text-gray-500 outline-none" onChange={(e) => setTelefoneAgendamento(e.target.value)} maxLength={15} value={aplicarMascara(telefoneAgendamento)} />
 */}
                </div>

              )
            }

            {
              ((isHibrido && !dadosChamada?.call?.phone) || (isHibrido && dadosChamada?.call?.phone && isAgendamento)) && (
                <div>
                  <p className='text-sm font-medium text-gray-500'>Telefone para retorno: </p>
                  <InputMask
                    mask="(99) 99999-9999"
                    name="Telefone"
                    // placeholder={'(99) 99999-9999'}
                    value={telefoneAgendamentoDigitado}
                    onChange={
                      (e: ChangeEvent<HTMLInputElement>) => setTelefoneAgendamentoDigitado(e.target.value)
                    }
                    className="h-full w-full bg-gray-200 p-2 placeholder:text-gray-600"
                  />
                </div>
              )
            }

            {
              isHibrido && dadosChamada?.call?.phone && !isAgendamento && (
                <div>
                  <p className='text-sm font-medium text-gray-500'>Telefone: </p>
                  <input
                    name="Telefone"
                    placeholder={dadosChamada?.call?.phone}
                    disabled
                    className="h-full w-full bg-gray-200 p-2 placeholder:text-gray-600"
                  />
                </div>
              )
            }



          </div>


          {isAgendamento && (
            <div className="  mb-2 flex w-[35%] flex-col gap-2">
              <p className="text-sm font-medium text-gray-500">Agendamento</p>
              <div className="flex w-full gap-2 ">
                <input
                  type="date"
                  min={format(new Date(), 'yyyy-MM-dd')}
                  className=" block rounded-md border border-gray-300 bg-gray-100 px-2.5 py-1.5 text-sm text-gray-500 outline-none"
                  onChange={(e) => setDataAgendamento(e.target.value)}
                />
                <input
                  type="time"
                  className=" block rounded-md border border-gray-300 bg-gray-100 px-2.5 py-1.5 text-sm text-gray-500 outline-none"
                  onChange={(e) => setHoraAgendamento(e.target.value)}
                  value={horaAgendamento}
                />
              </div>
            </div>
          )}
        </div>

        <div className="mb-2 w-full">
          <p className="text-sm font-medium text-gray-500">Observação</p>
          <textarea
            className=" block h-[40%] w-full resize-none rounded-md border border-gray-300 bg-gray-100 px-2.5 py-1.5 text-sm text-gray-500 outline-none "
            onChange={(e) => setObservacao(e.target.value)}
            value={observacao}
          ></textarea>
        </div>

        <Button
          name={tabualacao.finalizador === 'true' && !isOperador ? 'Finalizar' : 'Salvar'}
          onClick={() => {
            handleTabular();
          }}
          background={tabualacao.finalizador === 'true' && !isOperador ? 'bg-red-600' : ''}
        />
      </div>
    </div>
  );
};
